import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './BannerImage.module.css';



function BannerImage() {

    return (
        <>
            <div className={styles.bannerImage}>
                <picture >
                    <source className={styles.image} srcSet={"/images/dandies.jpg"} media="(max-width: 720px)" />
                    <img className={styles.image} src={"/images/dandies.jpg"} />
                </picture>
            </div>
        </>


    );
}

export default BannerImage;
